/* eslint-disable react-hooks/exhaustive-deps */

"use client";

import React, { Fragment, useEffect, useState } from "react";
import { InlineInfoBox, Divider } from "staysure-component-library";

import useMediaQuery from "@/hooks/use-media-query/use-media-query";
import {
  DocumentContainerAreaProps,
  PolicyDocuments,
} from "@/types/policy-document-types";

import DocumentItem from "./document-item";

function DocumentContent({
  documentContainerTitle,
  documentContainerContent,
  termsofBusinessLabel,
  termsofBusinessLink,
  policyDocData,
}: Readonly<
  DocumentContainerAreaProps & { policyDocData?: PolicyDocuments[] }
>) {
  const isDesktop = useMediaQuery("(min-width: 600px)");
  const [businessDocuments, setBusinessDocuments] = useState<PolicyDocuments[]>(
    []
  );

  const updatePolicyDocData = (docs: PolicyDocuments[]) => {
    const updatedPolicyDocs = [
      ...docs,
      {
        name: termsofBusinessLabel,
        link: termsofBusinessLink,
      },
    ];
    setBusinessDocuments(updatedPolicyDocs);
  };

  useEffect(() => {
    if (policyDocData) {
      updatePolicyDocData(policyDocData);
    }
  }, [policyDocData]);

  return (
    <div
      data-testid="documentContent-testid"
      className="flex flex-col gap-spacing-m md:gap-spacing-l"
    >
      <h1 className="font-header-font text-[20px] md:text-[31px] leading-[21px] md:leading-[34.1px] text-left text-text-title lg:py-0">
        {documentContainerTitle}
      </h1>

      <div>
        <InlineInfoBox
          id="traveler-form-inline-info-box"
          content={
            <div>
              {documentContainerContent ??
                "Please retain these documents during your travel as they contain vital information and contact numbers which you will need in the event of a claim or query."}
            </div>
          }
          style={{
            width: "100%",
            backgroundColor: "#EDF2FF",
            borderColor: "#006BD6",
            padding: "8px 16px 8px 16px",
            borderRadius: "8px",
            color: "#2E2E2E",
            fontSize: isDesktop ? "18px" : "16px",
            lineHeight: isDesktop ? "27px" : "24px",
          }}
        />
      </div>

      <div>
        {businessDocuments?.map((doc, index) => (
          <Fragment key={doc.link}>
            {index > 0 && (
              <Divider margin={isDesktop ? 24 : 16} color="#DCDCDC" />
            )}
            <DocumentItem name={doc.name} link={doc.link} id={index} />
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default DocumentContent;
